import React from 'react'
import { Link } from 'react-router-dom'
import unescape from 'lodash/unescape'

class ProgramBoxes extends React.Component {

  render(){
    const { item } = this.props
    const slug = "/program/" + item.slug
    const cdn = '/'

    let image = (item.bannerImage) ? item.bannerImage : (item.profileImage) ?  item.profileImage : cdn + 'assets/zedwall.jpg'
    image = image.replace(/(.*)\?cacbeb=[0-9]*$/g, '$1')

    return (
      <div className="pgrid" style={{order: item.index}} >
        <Link to={slug}>
         <div>
           <div className="show-image" style={{backgroundImage: 'url(' + image + ')'}} key={item.nid}> </div>
         </div>
         <div className="show-details">
           <div className="show-title">{item.name}</div>
           <div className="show-hosts">{unescape(item.broadcasters)}</div>
         </div>
         </Link>
      </div>
    )
  }
}
export default ProgramBoxes
